export default __webpack_public_path__ + "static/media/logo-app2d.c029ab69.svg";